import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CardType } from '@bciti/types';
import { Subject } from 'rxjs';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';

@Component({
    selector: 'app-add-card-dialog',
    templateUrl: './add-card-dialog.component.html',
    styleUrls: ['./add-card-dialog.component.scss'],
})
export class AddCardDialogComponent implements OnInit, OnDestroy {
    destroy$ = new Subject();
    loading = false;
    _selectedValue: CardType = CardType.BCITI;

    cardTypes: CardType[] = [CardType.BCITI, CardType.CITIZEN, CardType.LIBRARY, CardType.SPORTS];
    _noAvailables: boolean = false;
    constructor(private configService: ConfigurationService, private dialogRef: MatDialogRef<AddCardDialogComponent>, @Inject(MAT_DIALOG_DATA) private data: { cardsInUse: FormGroup[] }) {}

    ngOnInit(): void {
        this.loading = true;
        const cardsInUse = this.data.cardsInUse.map((card) => {
            return card.value.type;
        });
        if (cardsInUse.includes(CardType.BCITI)) {
            this.cardTypes.splice(this.cardTypes.indexOf(CardType.CITIZEN), 1);
        }
        if (cardsInUse.includes(CardType.CITIZEN)) {
            this.cardTypes.splice(this.cardTypes.indexOf(CardType.BCITI), 1);
        }
        this.cardTypes = this.cardTypes.filter((toRemove) => {
            return !cardsInUse.includes(toRemove);
        });
        if (this.cardTypes.length === 0) {
            this._noAvailables = true;
        } else {
            this._selectedValue = this.cardTypes[0];
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    get noAvailables() {
        return this._noAvailables;
    }

    set noAvailables(v) {
        this._noAvailables = v;
    }

    get selectedValue() {
        return this._selectedValue;
    }

    set selectedValue(v) {
        this._selectedValue = v;
    }

    close() {
        this.dialogRef.close();
    }

    submit() {
        this.dialogRef.close(this._selectedValue);
    }
}
